
import { ApplicationInsights } from '@microsoft/applicationinsights-web'

class CookieTracker {
    private _allowed: boolean;
  
    constructor() {
      this._allowed = false;
    }
  
    // Getter
    get allowed(): boolean {
      return this._allowed;
    }
  
    // Setter
    set allowed(allowed: boolean) {
      this._allowed = allowed;
    }
  }

export const CookieMonster = new CookieTracker();

export const getAppInsights = () => {

    let appInsights = null;
    if(appInsights == null) {
        appInsights = new ApplicationInsights({ config: {
            connectionString: 'InstrumentationKey=854ddd3b-e3cd-454a-88b5-ac9e1f4cc86c;IngestionEndpoint=https://canadacentral-1.in.applicationinsights.azure.com/;LiveEndpoint=https://canadacentral.livediagnostics.monitor.azure.com/;ApplicationId=98e81a29-3982-4938-8f99-8d2f025cfef9',
            disableCookiesUsage : CookieMonster.allowed
        } });
        appInsights.loadAppInsights();
    }
    return appInsights;
}